import { Component, Input, OnInit } from '@angular/core';
import { ImageInterface } from '../../../../../app-shared/models/image.interface';

@Component({
  selector: 'sb-display-input-radio',
  templateUrl: './display-input-radio.component.html',
  styleUrls: ['./display-input-radio.component.scss']
})
export class DisplayInputRadioComponent implements OnInit {
  @Input() title: string;
  @Input() images: ImageInterface[];
  @Input() checked: boolean;
  @Input() lean: boolean;
  @Input() invalid: boolean;
  @Input() disabled?: boolean;
  @Input() iconSize = 'normal';
  @Input() showRadioButton = false;

  ngOnInit(): void {
    this.images = this.images || [];
  }

}
